module.exports = __webpack_public_path__ + "img/cumhuriyet-banner-v1.6cf3f3dc.jpg";